import { httpService } from '@/services/HttpService';

class BillingService {
  getCurrentCost(workspaceId: number): Promise<any> {
    return httpService.get(`workspaces/${workspaceId}/usage_cost/current`);
  }
  getExpectedCost(workspaceId: number): Promise<any> {
    return httpService.get(`workspaces/${workspaceId}/usage_cost/monthly_expected`);
  }
  bandwidthMonthlyUpload(workspaceId: number, regionId: number): Promise<any> {
    return httpService.get(`workspaces/${workspaceId}/regions/${regionId}/bandwidth/monthly_upload`, '', {
      isErrorSuppressed: true,
    });
  }
  repay(workspaceId: number, billingPeriodId: number, payment_uuid: string): Promise<any> {
    return httpService.post(`workspaces/${workspaceId}/billing_periods/${billingPeriodId}/repay`, { payment_uuid });
  }
  getReport(workspaceId: number, dateFrom: string, dateTo: string): Promise<any> {
    return httpService.get(
      `workspaces/${workspaceId}/billing/report?start_time=${encodeURIComponent(
        dateFrom
      )}&end_time=${encodeURIComponent(dateTo)}`
    );
  }
  getBillingReport(workspaceId: number, billingPeriodId: any): Promise<any> {
    return httpService.get(`workspaces/${workspaceId}/billing_periods/${billingPeriodId}/report`);
  }
  getBillingPeriods(workspaceId: number): Promise<any> {
    return httpService.get(`workspaces/${workspaceId}/billing_periods`, '', { isErrorSuppressed: true });
  }
  getBillingReportPDF(workspaceId: number, billingPeriodId: any): Promise<any> {
    return httpService.getWithHeadersBinary(`workspaces/${workspaceId}/billing_periods/${billingPeriodId}/report/pdf`);
  }
  getCustomReportPDF(workspaceId: number, dateFrom: string, dateTo: string): Promise<any> {
    return httpService.getWithHeadersBinary(
      `workspaces/${workspaceId}/billing/report/pdf?start_time=${encodeURIComponent(
        dateFrom
      )}&end_time=${encodeURIComponent(dateTo)}`
    );
  }
  getBillingReportCSV(workspaceId: number, billingPeriodId: any): Promise<any> {
    return httpService.get(`workspaces/${workspaceId}/billing_periods/${billingPeriodId}/report/csv`);
  }
  getCustomReportCSV(workspaceId: number, dateFrom: string, dateTo: string): Promise<any> {
    return httpService.get(
      `workspaces/${workspaceId}/billing/report/csv?start_time=${encodeURIComponent(
        dateFrom
      )}&end_time=${encodeURIComponent(dateTo)}`
    );
  }
}

export const billingService = new BillingService();
